import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import GatsbyImage from "gatsby-image/withIEPolyfill"

const Image = ({ fileName, alt }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulAsset {
        nodes {
          file {
            fileName
          }
          fluid(maxWidth: 800, maxHeight: 700) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
    }
  `)

  const image = data.allContentfulAsset.nodes.find(node => {
    return node.file.fileName.includes(fileName)
  })

  return <GatsbyImage fluid={image.fluid} alt={alt} />
}

export default Image
